import { render } from "./PersonalInfo.vue?vue&type=template&id=1d856376&scoped=true"
import script from "./PersonalInfo.vue?vue&type=script&lang=js"
export * from "./PersonalInfo.vue?vue&type=script&lang=js"

import "./PersonalInfo.vue?vue&type=style&index=0&id=1d856376&lang=scss&scoped=true"
script.render = render
script.__scopeId = "data-v-1d856376"

export default script